export const messages = {
  en: {
    editWork: {
      title: 'Edit Work Order',
      workName: 'Title',
      workNamePlaceholder: 'Required, please enter title',
      workType: 'Work Order Type',
      workTypePlaceholder: 'Required, please select work order type',
      processor: 'Processor',
      ccPerson: 'CC Person',
      choose: 'Choose',
      workSign: 'Work Order Sign',
      workSignPlaceholder: 'Required, please select work order sign',
      onceWork: 'One-time Work Order',
      cycleWork: 'Periodic Work Order',
      attachment: 'Attachment',
      startTime: 'Start Time',
      startTimePlaceholder: 'Required, please enter start time',
      endTime: 'End Time',
      endTimePlaceholder: 'Required, please enter end time',
      period: 'Period',
      periodPlaceholder: 'Required, please select task period',
      monthDay: 'Month/Day',
      byWeek: 'By Week',
      workHours: 'Work Hours',
      workHoursPlaceholder: 'Required, please enter hours',
      hoursComplete: 'hours to complete',
      month: 'Month',
      monthUnit: 'Month',
      day: 'Day',
      dayUnit: 'Day',
      week: 'Week',
      monday: 'Monday',
      tuesday: 'Tuesday',
      wednesday: 'Wednesday',
      thursday: 'Thursday',
      friday: 'Friday',
      saturday: 'Saturday',
      sunday: 'Sunday',
      content: 'Content',
      add: 'Add',
      delete: 'Delete',
      contentPlaceholder: "Please enter content",
    },
    uploadFile: {
      upload: 'Upload Attachment',
      sizeLimit: 'File size cannot exceed 20MB',
      success: 'File uploaded successfully',
      failed: 'File upload failed'
    },
    textarea: {
      placeholder: 'Required, please enter content',
      uploadFailed: 'Image upload failed'
    },
  },
  zh: {
    editWork: {
      title: '修改工作单',
      workName: '标题',
      workNamePlaceholder: '必填，请填写标题',
      workType: '工作单类型',
      workTypePlaceholder: '必填，请选择工作单类型',
      processor: '处理人',
      ccPerson: '抄送人',
      choose: '选择',
      workSign: '工作单标识',
      workSignPlaceholder: '必填，请选择工作单标识',
      onceWork: '一次性工单',
      cycleWork: '周期性工单',
      attachment: '附件',
      startTime: '开始时间',
      startTimePlaceholder: '必填，请填写开始时间',
      endTime: '结束时间',
      endTimePlaceholder: '必填，请填写结束时间',
      period: '周期',
      periodPlaceholder: '必填，请选择任务周期',
      monthDay: '月/天',
      byWeek: '按周',
      workHours: '工作单',
      workHoursPlaceholder: '必填，请输入小时数',
      hoursComplete: '小时内完成',
      month: '月',
      monthUnit: '月',
      day: '日',
      dayUnit: '日',
      week: '周',
      monday: '星期一',
      tuesday: '星期二',
      wednesday: '星期三',
      thursday: '星期四',
      friday: '星期五',
      saturday: '星期六',
      sunday: '星期日',
      content: '内容',
      add: '添加',
      delete: '删除',
      contentPlaceholder: "请输入内容",
    },
    uploadFile: {
      upload: '上传附件',
      sizeLimit: '文件大小不能超过20MB',
      success: '文件上传成功',
      failed: '文件上传失败'
    },
    textarea: {
      placeholder: '必填，请输入内容',
      uploadFailed: '图片上传失败'
    },
  }
}